<div class="breadcrumb-area">
  <h1>Reportes Varios (Extracciones)</h1>
</div>

<div class="card mb-3" id="mayeVariousReport">
  <div class="title-report card-header d-flex justify-content-between align-items-center"
       (click)="toggleSection()">
    <h3>Notas de Entrada</h3>
    <h3>
      <i [ngClass]="isOpen ? 'fa-minus' : 'fa-plus'" class="fa"></i>
    </h3>
  </div>

  <div class="card-body" *ngIf="isOpen">
    <div class="row mb-3">
      <div class="col-sm-12 text-muted">
        <i class="fa fa-circle-info"></i>
        Este reporte muestra las notas de entrada de la empresa actual.
        Puedes descargarlo en formato Excel o PDF.s
      </div>
    </div>

    <div class="row mb-4">
        <div class="col-sm">
            <div class="form-group">
                <label for="startDate6" class="form-label">Fecha Inicial:</label>
                <input type="date" [(ngModel)]="startDate" id="startDate6" name="startDate6" class="form-control">
            </div>
        </div>
        <div class="col-sm">
            <div class="form-group">
                <label for="endDate6" class="form-label">Fecha Final:</label>
                <input type="date" [(ngModel)]="endDate" id="endDate6" name="endDate6" class="form-control">
            </div>
        </div>
    </div>

    <div class="row align-items-center">
      <div class="col-sm-3">
        <button class="btn btn-success w-100" (click)="downloadReport('excel')"
                [disabled]="btnExcel.loading">
          <i *ngIf="!btnExcel.loading" class="fa fa-file-excel"></i>
          <span *ngIf="btnExcel.loading" class="spinner-border spinner-border-sm"></span>
          Excel
        </button>
      </div>

      <div class="col-sm-3">
        <button class="btn btn-primary w-100" (click)="downloadReport('pdf')"
                [disabled]="btnPdf.loading">
          <i *ngIf="!btnPdf.loading" class="fa fa-file-pdf"></i>
          <span *ngIf="btnPdf.loading" class="spinner-border spinner-border-sm"></span>
          PDF
        </button>
      </div>

      <!-- <div class="col-sm-6 text-end text-muted">
        <small>Última actualización: {{ lastDownloadDate | date: 'dd/MM/yyyy HH:mm' }}</small>
      </div> -->
    </div>
  </div>
</div>


<div class="card mb-3" id="mayeVariousReport">
  <div class="title-report card-header d-flex justify-content-between align-items-center"
       (click)="toggleSection()">
    <h3>Notas de Despacho/Salida</h3>
    <h3>
      <i [ngClass]="isOpen ? 'fa-minus' : 'fa-plus'" class="fa"></i>
    </h3>
  </div>

  <div class="card-body" *ngIf="isOpen">
    <div class="row mb-3">
      <div class="col-sm-12 text-muted">
        <i class="fa fa-circle-info"></i>
        Este reporte muestra las notas de salida de la empresa actual.
        Puedes descargarlo en formato Excel o PDF.s
      </div>
    </div>

    <div class="row mb-4">
        <div class="col-sm">
            <div class="form-group">
                <label for="startDate6" class="form-label">Fecha Inicial:</label>
                <input type="date" [(ngModel)]="startDate" id="startDate6" name="startDate6" class="form-control">
            </div>
        </div>
        <div class="col-sm">
            <div class="form-group">
                <label for="endDate6" class="form-label">Fecha Final:</label>
                <input type="date" [(ngModel)]="endDate" id="endDate6" name="endDate6" class="form-control">
            </div>
        </div>
    </div>

    <div class="row align-items-center">
      <div class="col-sm-3">
        <button class="btn btn-success w-100" (click)="downloadReportExitNote('excel')"
                [disabled]="btnExcel.loading">
          <i *ngIf="!btnExcel.loading" class="fa fa-file-excel"></i>
          <span *ngIf="btnExcel.loading" class="spinner-border spinner-border-sm"></span>
          Excel
        </button>
      </div>

      <div class="col-sm-3">
        <button class="btn btn-primary w-100" (click)="downloadReportExitNote('pdf')"
                [disabled]="btnPdf.loading">
          <i *ngIf="!btnPdf.loading" class="fa fa-file-pdf"></i>
          <span *ngIf="btnPdf.loading" class="spinner-border spinner-border-sm"></span>
          PDF
        </button>
      </div>

      <!-- <div class="col-sm-6 text-end text-muted">
        <small>Última actualización: {{ lastDownloadDate | date: 'dd/MM/yyyy HH:mm' }}</small>
      </div> -->
    </div>
  </div>
</div>